<template>
  <div class="grid row">
    <div class="flex xs12">
      <va-card title="Certificates" class="fill-height">
        <div>
          <div class="row">
            <div class="flex xs12">
              <va-tabs v-model="tabValue" style="width: 100%; min-width: 250px; margin-bottom: 25px;">
                <va-tab
                  v-for="title in tabTitles"
                  :key="title"
                >
                  {{title}}
                </va-tab>
              </va-tabs>
              <div class="flex xs12" v-if="tabValue === 0">
                <va-input
                  label="Header"
                  v-model="main.intro.header"
                  :messages="['The recommended number of characters is 15']"
                />
                <va-card class="mb-3" title="Image">
                  <div v-if="imgIntroExisting">
                    <img style="max-width: 300px; display: block; margin-bottom: 10px;" :src="imgIntroExisting" alt="intro image"/>
                    <va-button small color="danger" @click="imgIntroExisting = ''; imageNew = null">Видалити</va-button>
                  </div>
                  <span>Завантажити нове зображення</span>
                  <va-file-upload
                    dropzone
                    v-model="img"
                    style="margin-bottom: 25px;"
                  />
                  <va-button @click="uploadImage(img[0])">Завантажити</va-button>
                </va-card>
                <va-button @click="submit()">Save</va-button>
              </div>
              <div class="flex xs12" v-if="tabValue === 1">
                <va-button @click="$router.push({ name: 'bgk-page-certificates-edit' })">Add Certificate</va-button>
                <va-data-table
                  :fields="tabFields"
                  :data="items"
                  no-pagination
                >
                  <template slot="toggle" slot-scope="props">
                    <va-toggle
                      small
                      v-on:input="togglePublished(props.rowData.id)"
                      v-model="props.rowData.published"
                    />
                  </template>

                  <template slot="actions" slot-scope="props">
                    <va-button
                      small
                      color="info"
                      :to="{ name: 'bgk-page-certificates-edit', params: { id: props.rowData.id } }"
                    >
                      Редагувати
                    </va-button>
                    <va-button
                      small
                      @click="remove(props.rowData.id)"
                      color="danger"
                      class="ma-0"
                    >
                      Видалити
                    </va-button>
                  </template>
                </va-data-table>
              </div>
            </div>
          </div>
        </div>
      </va-card>
    </div>
  </div>
</template>

<script>
import * as axios from 'axios'
import Vue from 'vue'

export default {
  name: 'grid',
  data () {
    return {
      main: {
        intro: {
          header: null,
          image: null,
        },
      },
      items: [],

      imgIntroExisting: null,
      imageNew: null,
      img: [],

      errors: [],

      tabTitles: ['Main', 'Certificates'],
      tabValue: 0,
    }
  },
  created () {
    this.fetch()
  },
  methods: {
    togglePublished (id) {
      axios.put(`${process.env.VUE_APP_BGK_API_URL}/${this.locale}/admin/certificates/${id}`, {
        published: !!this.items.find((item) => item.id === id).published,
      })
        .then(() => { this.showToast('Success') })
        .catch(error => {
          console.log(error)
          this.showToast('Error')
        })
    },
    submit () {
      if (this.imageNew) {
        this.main.intro.image = this.imageNew
      }
      axios.put(`${process.env.VUE_APP_BGK_API_URL}/${this.locale}/admin/pages/certificates`, { main: this.main })
        .then(() => {
          this.showToast('Success')
        })
        .catch(error => {
          if (error.response.status === 422) {
            this.errors = error.response.data.errors
          }
          console.log(error)
          this.showToast('Error')
        })
    },
    fetch () {
      axios.get(`${process.env.VUE_APP_BGK_API_URL}/${this.locale}/admin/pages/certificates`)
        .then(response => {
          this.main = response.data.main
          this.items = response.data.items
          this.imgIntroExisting = this.main.intro.image
            ? `${process.env.VUE_APP_BGK_URL}${this.main.intro.image}`
            : null
        })
        .catch(error => {
          console.log(error)
          this.showToast('Error')
        })
    },
    remove (id) {
      if (confirm('Дійсно видалити?')) {
        axios.delete(`${process.env.VUE_APP_BGK_API_URL}/${this.locale}/admin/certificates/${id}`)
          .then(() => {
            const idx = this.items.findIndex(u => u.id === id)
            this.items.splice(idx, 1)
            this.showToast('Success')
          })
          .catch(error => {
            console.log(error)
            this.showToast('Error')
          })
      }
    },
    uploadImage (file) {
      if (!file) return
      const formData = new FormData()
      formData.append('file', file)
      axios.post(`${process.env.VUE_APP_BGK_API_URL}/${this.locale}/admin/media`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
        .then(response => {
          this.imageNew = response.data.patch
          this.imgIntroExisting = `${process.env.VUE_APP_BGK_URL}${response.data.patch}`
          this.showToast('Successful upload')
        })
        .catch(error => {
          console.log(error)
          this.showToast('Error')
        })
    },
  },
  computed: {
    tabFields () {
      return [
        { name: 'id', title: 'ID', width: '5%' },
        { name: 'name', title: 'Name', width: '40%' },
        { name: 'file_uk', title: 'File UA', width: '20%' },
        { name: 'file_en', title: 'File EN', width: '20%' },
        { title: 'Опубліковано', name: '__slot:toggle', width: '10%' },
        { name: '__slot:actions', dataClass: 'text-right' },
      ]
    },
    locale () {
      return Vue.i18n.locale()
    },
  },
  watch: {
    locale (value) {
      this.fetch()
    },
  },
}
</script>

<style lang="scss">
.grid {
  &__container {
    min-height: 3rem;
    color: $white;
    border-radius: 0.5rem;
  }
}
</style>
